"use client";

import { useState } from "react";

function playerInitials(name: string) {
  const parts = String(name || "").trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Flush square that stretches to match the row's height (via self-stretch on
// a flex parent) — pass `className` to control width; height and squareness
// follow automatically from aspect-square.
export default function PlayerAvatar({
  name, colorClass, photoUrl, muted,
  className = "w-14 sm:w-16 self-stretch",
  textSizeClass = "text-sm sm:text-base",
}: {
  name: string;
  colorClass: string;
  photoUrl?: string | null;
  muted?: boolean;
  className?: string;
  textSizeClass?: string;
}) {
  const [imgFailed, setImgFailed] = useState(false);

  if (photoUrl && !imgFailed) {
    return (
      <img
        src={photoUrl}
        alt=""
        onError={() => setImgFailed(true)}
        className={`${className} aspect-square object-cover shrink-0 bg-zinc-800`}
      />
    );
  }

  const tint = muted ? "text-zinc-500" : colorClass;
  return (
    <span className={`${tint} ${className} aspect-square bg-[currentColor]/10 flex items-center justify-center ${textSizeClass} font-bold shrink-0`}>
      {playerInitials(name)}
    </span>
  );
}
